module.exports = __webpack_public_path__ + "img/portfolio1.2f04315e.jpg";